export default "__VITE_PUBLIC_ASSET__30f6622d__"